import { RouterProvider } from "react-router-dom";
import { router } from "@routes/index";

/**
 * Root Application Component
 *
 * This is the entry point for the React application.
 * It sets up the router provider and any global providers.
 */
function App() {
  return <RouterProvider router={router} />;
}

export default App;
